import { Component } from '@angular/core';

@Component({
    selector: 'app-prestamos-tabs',
    templateUrl: './prestamos-tabs.component.html',
    styleUrls: [],
    standalone: false
})

export class PrestamosTabsComponent {

  routes: object[];

  constructor() {
    this.routes = [
      { label: 'Prestamos', link: '/finance/loans/banksloans', enable: true },
      { label: 'Financiacion Propia', link: '/finance/loans/selffinancing', enable: true },
      { label: 'Financiacion Privada', link: '/finance/loans/privatefinancing', enable: true },
    ];
  }

}
